import React, { Fragment } from "react";
import promo from "../../../../images/H3-images-2.jpg";
import clock from "../../../../images/clock.png";
import fly from "../../../../images/h3-slider-fly.png";
import gk from "../../../../images/gk.png";
import images from "../../../../images/H3-images-3.jpg";
import { Link } from "react-router-dom";

function AppPromo() {
  return (
    <Fragment>
       <div className="flight-sec blue-back gk-sec">
                <img loading="lazy" data-aos="zoom-in-right" className="gk-back" src={gk} alt="images" />
                <img loading="lazy" data-aos="zoom-in-right" className="plan" src={fly} alt="images" />
                <img loading="lazy" data-aos="zoom-in-right" className="clock" src={clock} alt="images" />
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="about-sec">
                                <div className="slider-header">
                                    <div>
                                    <h3>Get Ready for an Adventure!</h3>
                                    <p data-aos="zoom-in-left">Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30 less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab great deals, and let the thrill of savings fuel your dream getaway! 🌟💸🚀</p>
                                   <Link to="/deal">View More <img src="/images/right.svg" alt="Right Arrow" /></Link>
                                    </div>
                                    <div data-aos="zoom-in-right" className="pic-collage"> <img loading="lazy" className="gk-rotate" src={promo} alt="promo" /> <img loading="lazy" className="gk-rotate2" src={images} alt="images" /></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </Fragment>
  );
}

export default AppPromo;
